<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" md="6">
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  data: () => ({
    ImportacionEmpleadosLoadding: false,
    params: {},
    urlMain: null,
    chosenFile: null
  }),
  mounted () {},
  methods: {
    ...mapActions(['getUrlServices']),
    ...mapMutations([])
  },
  computed: {
    ...mapGetters(['get_urls'])
  },
  watch: {
    get_urls () {
      this.ExecuteUrl(this.urlMain)
    }
  }
}
</script>

<style scoped>
</style>
